import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Textfield, Loader } from "cxa-components";
import { connect } from "react-redux";
import ActivityList from "./activityList";
import { loadShopActivities, resetReload } from "actions/shopActivitiesActions";
import Pager from "../../pager";
import querystring from "querystring";
import { pageSizePresets } from "reducers/libraryCatalogueReducer";
import { intlShape, injectIntl } from "react-intl";
import messages from "components/messagesDescription";

const removeDefaultParams = params =>
  Object.entries(params).reduce((obj, [key, value]) => {
    return value
      ? Array.isArray(value)
        ? value.length === 0 ? obj : { ...obj, [key]: value.sort().join(",") }
        : (key === "search" && value === "") ||
          (key === "page" && value == 1) ||
          (key === "sortBy" && value == 0) ||
          (key === "pageSize" && value == pageSizePresets.lower) ||
          (key === "minPrice" && value == 0) ||
          (key === "maxPrice" && value == 0)
          ? obj
          : { ...obj, [key]: value }
      : obj;
  }, {});

class BrowseActivities extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: props.queryParams.searchKeyword || "",
    };
  }

  componentDidMount() {
    this.reloadData(this.props.queryParams);
  }

  reloadData(queryParams) {
    this.props.resetReload();
    this.props.loadShopActivities(queryParams.page, queryParams.searchKeyword);
  }

  componentWillUpdate(nextProps) {
    const props = nextProps;

    if (
      props.queryParams.searchKeyword !== this.props.queryParams.searchKeyword
    ) {
      this.setState({
        search: props.queryParams.searchKeyword,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.search !== this.props.search || this.props.shouldReload) {
      this.reloadData(this.props.queryParams);
    }
  }

  onSearchChange = e => {
    this.setState({
      search: e.currentTarget.value,
    });
  };

  render() {
    const { props } = this;
    const intl = props.intl;
    if (props.fetching || !props.data) {
      return <Loader />;
    }

    const stringifyQuery = params => {
      const finalParams = removeDefaultParams(params);
      return querystring.stringify(finalParams);
    };

    const { data, queryParams, pathname, push, fetching } = props;
    const { pageSize, page } = queryParams;
    const link = target =>
      `${pathname}?${stringifyQuery({
        ...queryParams,
        page: Number.parseInt(target) + 1,
      })}`;

    const updateQueryString = queryStr => {
      push(pathname + (queryStr.length > 0 ? "?" : "") + queryStr);
    };

    const onSearchSubmit = e => {
      e.preventDefault();

      const value = this.state.search;
      const { searchKeyword, page, ...rest } = queryParams;
      const additionalProps = value.length > 0 ? { searchKeyword: value } : {};
      updateQueryString(stringifyQuery({ ...rest, ...additionalProps }));
    };

    return (
      <div>
        <form onSubmit={onSearchSubmit} className="form--search">
          <p>
            <Textfield
              size="40"
              boxed
              placeholder={intl.formatMessage(messages.searchTextDescription)}
              onChange={this.onSearchChange}
              value={this.state.search}
            />
          </p>
          <p>
            <Button>
              {intl.formatMessage(messages.searchTextDescription)}
            </Button>
          </p>
        </form>

        <div className="apl-search__filters--secondary">
          <p>
            {intl.formatMessage(messages.showResultsDescription, {
              value0: data.recordsFound,
            })}
          </p>
        </div>
        <div>
          {fetching ? (
            <Loader />
          ) : (
            <div>
              <ActivityList
                activities={data.activities}
                showCount={true}
                showStatus={false}
                showProvider={false}
                showDownload={false}
                showVoucherActions={false}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

BrowseActivities.propTypes = {
  loadShopActivities: PropTypes.func,
  resetReload: PropTypes.func,
  data: PropTypes.object,
  fetching: PropTypes.bool,
  search: PropTypes.string,
  queryParams: PropTypes.object,
  searchKeyword: PropTypes.string,
  shouldReload: PropTypes.bool,
  intl: intlShape.isRequired,
};

const mapStateToProps = function(store, ownProps) {
  const { location, query } = ownProps;

  return {
    error: store.shopActivities.error,
    data: store.shopActivities.data,
    fetching: store.shopActivities.fetching,
    shouldReload: store.shopActivity.shouldReload,
    pathname: location.pathname,
    search: location.search,
    queryParams: {
      searchKeyword: query.searchKeyword,
      page: query.page ? parseInt(query.page) : 1,
      pageSize: query.pageSize ? query.pageSize : pageSizePresets.lower,
    },
  };
};

const mapDispatchToProps = dispatch => ({
  loadShopActivities: (page, keyword) =>
    dispatch(loadShopActivities(page, keyword, false)),
  resetReload: () => dispatch(resetReload()),
});

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(BrowseActivities)
);



// WEBPACK FOOTER //
// ./components/wellness/activities/browseActivities.jsx